import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Truck, ExternalLink } from "lucide-react";

const STATUS_LABEL = {
    awaiting_approval: "Aguarda aprovação",
    stock_confirmed: "Stock confirmado",
    preparing: "Em preparação",
    ready_to_ship: "Pronto para envio",
    label_generated: "Etiqueta gerada",
    picked_up: "Recolhido",
    in_transit: "Em trânsito",
    out_for_delivery: "Saiu para entrega",
    delivered: "Entregue",
    returned: "Devolvido",
    cancelled: "Cancelado",
};

export default function AdminShipments() {
    const [list, setList] = useState([]);
    const [filter, setFilter] = useState("all");

    useEffect(() => { api.get("/admin/shipments").then((r) => setList(r.data)); }, []);

    const filtered = filter === "all" ? list : list.filter((s) => s.status === filter);

    const counts = list.reduce((acc, s) => ({ ...acc, [s.status]: (acc[s.status] || 0) + 1 }), {});

    return (
        <section className="space-y-6" data-testid="admin-shipments">
            <div>
                <span className="label-overline text-wine/60">Logística</span>
                <h1 className="font-heading text-3xl text-wine-dark">Envios</h1>
                <p className="text-sm text-wine-dark/60 mt-1">Visão global de todos os envios da plataforma (todos os produtores).</p>
            </div>

            <div className="flex flex-wrap gap-1 bg-cream rounded-md p-1 w-fit">
                <button onClick={() => setFilter("all")} className={`px-3 py-1.5 rounded-md text-xs uppercase tracking-wider ${filter === "all" ? "bg-wine text-cream" : "text-wine-dark/60"}`}>Todos ({list.length})</button>
                {Object.entries(counts).map(([k, n]) => (
                    <button key={k} onClick={() => setFilter(k)} className={`px-3 py-1.5 rounded-md text-xs uppercase tracking-wider whitespace-nowrap ${filter === k ? "bg-wine text-cream" : "text-wine-dark/60"}`}>
                        {STATUS_LABEL[k]} ({n})
                    </button>
                ))}
            </div>

            <div className="bg-white rounded-md border border-gold-soft/30 overflow-hidden">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-left label-overline text-wine-dark/60 border-b border-wine-dark/10 bg-cream/40">
                            <th className="py-3 px-4">Envio</th>
                            <th>Produtor</th>
                            <th>Destino</th>
                            <th>Itens</th>
                            <th className="text-right px-2">Subtotal</th>
                            <th className="text-right px-2">Frete</th>
                            <th>Estado</th>
                            <th>Tracking</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map((s) => (
                            <tr key={s.id} className="border-t border-wine-dark/5 hover:bg-cream">
                                <td className="py-3 px-4 font-mono text-xs">#{s.id.slice(0, 8)}</td>
                                <td className="text-wine-dark">{s.producer_name}</td>
                                <td className="text-xs text-wine-dark/65">{(s.shipping_address || {}).city || "—"}</td>
                                <td className="text-xs text-wine-dark/70">{s.items.length}</td>
                                <td className="text-right px-2 text-wine-dark">€{s.subtotal.toFixed(2)}</td>
                                <td className="text-right px-2 text-gold-deep">€{(s.shipping_cost || 0).toFixed(2)}</td>
                                <td><span className="label-overline text-[10px] px-2 py-1 rounded bg-wine/10 text-wine">{s.status_label || STATUS_LABEL[s.status]}</span></td>
                                <td className="text-xs">
                                    {s.tracking_code ? (
                                        <Link to={`/tracking/${s.tracking_code}`} target="_blank" className="font-mono text-wine inline-flex items-center gap-1 hover:text-gold-deep">
                                            {s.tracking_code} <ExternalLink className="h-3 w-3" />
                                        </Link>
                                    ) : <span className="text-wine-dark/30">—</span>}
                                </td>
                            </tr>
                        ))}
                        {filtered.length === 0 && (
                            <tr><td colSpan="8" className="text-center py-10 text-wine-dark/60">Sem envios.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="bg-gold-soft/10 border border-gold-soft/40 rounded-md p-4 text-xs text-wine-dark/70 flex items-start gap-3">
                <Truck className="h-4 w-4 text-wine flex-shrink-0 mt-0.5" />
                <span>A plataforma <strong>não realiza envio próprio</strong>. Cada produtor é responsável por embalar, contratar a transportadora e adicionar o tracking nesta plataforma. Integrações automáticas com CTT/DHL/DPD estão no roadmap.</span>
            </div>
        </section>
    );
}
